module.exports = __webpack_public_path__ + "static/media/SocialShare.5bd1c6cb.svg";